/* eslint-disable no-unused-vars */

// recommendation question group ids

export const RECOMMENDATION_QUESTION_GROUP = {
  IMMUNITY: '면역',
  YOUTH: '어린이/청소년 건강',
  WOMAN: '중년 여성 건강',
  MAN: '중년 남성 건강',
  ANTIOXIDATION: '항산화',
  EYE: '눈 건강',
  ENERGY: '활력',
};

// remains for JM
export const STORE_ACTIONS = {
  RECOMMENDATION: {
    INIT: 'recommendation/init',
  },
  PRODUCT: {

  },
  SURVEY: {

  },
};

export const AGREEMENT_TYPE = {
  PRIVACY: 'privacy',
  REFUND: 'refund',
  SENSITIVE: 'sensitive',
  CONSULTATION: 'consultation',
  PROXY_CONSENT: "proxy_consent",
  LIMITATION: 'limitation',
  NO_RESALE: 'no_resale',
  VCALL_PRIVACY: 'vcall_privacy',
  VCALL_RESEVE: 'vcall_reseve',
  CHAT_GUIDELINE: 'chat_guideline',
};

export const INTAKER_TYPE = {
  SELF: "본인",
  OTHER: "본인 외",
};

export const CONTEXT_TYPE = {
  COMPOSITION: 'composition',
  RECOMPOSITION: 'recomposition',
  RECOMPOSITION_WITH_REQNO: 'recomposition-with-reqno',
  COMPOSITION_FINAL: 'composition-final',
  COMPOSITION_REORDER: 'composition-reorder',
  COMPOSITION_PAYMENT_WITH_REQNO: 'composition-payment-with-reqno',
};

export const KEEP_SESSION_INTERVAL_IN_SEC = 26 * 60 * 1000; // 26m
export const ASSETS_IMAGE_THUMBS_PATH = '/static/images/thumbs';

export const REQUEST_USER_STATES = {
  A1: "마이팩 채팅 상담 예정",
  A2: "마이팩 ABC 상담 예정",
  A3: "정기 구매 승인 예정",
  C1: "정기 구매 승인 완료",
  C2: "단종 또는 재고 소진",
  C3: "결제 실패",
  B: "마이팩 취소",
  H: "상담 미완료",
  D: "상담 및 결제 완료",
  E: "마이팩 포장 시작",
  F: "마이팩 포장 완료",
  G: "마이팩 결제 취소",
};

export const PICKUP_METHODS = {
  PICK_UP: 'pickup',
  DELIVERY: 'delivery',
  VCALL: 'VCALL',
  ABC: 'ABC',
};

export const PAYMENT_METHODS = {
  AMWAY_PAY: "amwaypay",
  NORMAL: "normal",
};

export const AMWAY_PAY_METHODS = {
  QUICK_ACCOUNT: "quickaccount",
  ACCOUNT: "apayaccount",
  CARD: "apaycreditcard",
};

export const NORMAL_PAYMENT_METHODS = {
  TRANSFER: 'transfer',
  CREDIT_CARD: 'creditcard',
};

export const BILLING_PAYMENT_MODE = {
  QUICK_ACCOUNT: "quickaccount",
  CREDIT_CARD: "creditcard",
}

export const QUICK_ACCOUNT_PAYMENT_TYPE = {
  BILLING: "billing",
  NORMAL: "normal",
}

export const CASH_RECEIPT_REG_TYPE = {
  BIZ_REG_NUM: 'BRN',
  CARD_NUM: 'CDN',
  MOBILE_NUM: 'CPN',
};

export const CASH_RECEIPT_CATEGORY = {
  PERSONAL: 'INCOME_DEDUCTION',
  BIZ: 'EXPENDITURE_PROOF',
};

export const ERRORS = {
  LOGIN: {
    NOT_LOGGED_IN: 'not-logged-in',
    NOT_A_ABO_MEMBER: 'not-a-abo-member',
  },
  REQUEST: {
    REQUEST_LIMIT_EXCEEDED: 'REQUEST_LIMIT_EXCEEDED',
  },
};

export const PACK_STATUS_CODE = {
  CONSULTATION_REQUESTED: 'A',
  CONSULTATION_CANCELED: 'B',
  CONSULTATION_FINISHED: 'C',
  CONSULTATION_INCOMPLETED: 'H',
};

export const ORDER_STATUS_CODE = {
  PAYMENT_FINISHED: 'D',
  PAYMENT_CANCELED: 'G',
  DIVISION_STARTED: 'E',
  DIVISION_FINISHED: 'F',
};

export const USER_STATUS_CODE = {
  CONSULTATION_SCHEDULED_VCALL: 'A1',
  CONSULTATION_SCHEDULED_ABC: 'A2',
  CONSULTATION_SCHEDULED_RECURRING: 'A3',
  RECURRING_PURCHASE_APPROVED: 'C1',
  PRODUCT_UNAVAILABLE: 'C2',
  PAYMENT_FAILED: 'C3',
  CONSULTATION_CANCELED: 'B',
  CONSULTATION_INCOMPLETED: 'H',
  PAYMENT_FINISHED: 'D',
  DIVISION_STARTED: 'E',
  DIVISION_FINISHED: 'F',
  PAYMENT_CANCELED: 'G',
  PAYMENT_INSTALLMENT: 'I'
};

export const DOUBLE_X_SKU = '303697K';
export const DELIVERY_FEE_SKU = '305110K';
export const PACKAGE_WRAPPING_FEE_SKU = '305120K';

export const JSON_HEADER = {
  "Accept": "application/json",
  "Content-Type": "application/json;charset=UTF-8",
};
